import ChecklistThemeSubSectionComponent, {
  ChecklistThemeSubSectionComponentProps,
} from './ChecklistThemeSubSectionComponent';

export default ChecklistThemeSubSectionComponent;

export type { ChecklistThemeSubSectionComponentProps };
